var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJackpotStarGoldDesktopIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 221,
    viewBox: "0 0 230 221",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.6027 15.2867C103.485 -0.707538 126.291 -0.707538 134.173 15.2867L150.851 49.1274C154.712 56.9624 162.186 62.3914 170.831 63.6404L208.187 69.0376C225.84 71.5881 232.89 93.2861 220.107 105.725L193.073 132.032C186.809 138.128 183.953 146.92 185.44 155.532L191.879 192.832C194.913 210.407 176.462 223.822 160.679 215.515L127.23 197.91C119.504 193.844 110.271 193.844 102.546 197.91L69.0966 215.515C53.3137 223.822 34.8622 210.407 37.8964 192.832L44.3357 155.532C45.8226 146.92 42.9671 138.128 36.7031 132.032L9.66894 105.725C-3.11416 93.2861 3.93544 71.5881 21.5886 69.0376L58.9442 63.6404C67.5893 62.3914 75.0636 56.9624 78.9249 49.1274L95.6027 15.2867Z",
    fill: "url(#paint0_linear_971_8295)",
    stroke: "url(#paint1_linear_971_8295)",
    strokeWidth: 5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_971_8295",
    x1: 56.1972,
    y1: 83.4257,
    x2: 115.984,
    y2: 220.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D59130"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14375,
    stopColor: "#FCE268"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211458,
    stopColor: "#FFFEC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279167,
    stopColor: "#FFE86C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414583,
    stopColor: "#A4601B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607292,
    stopColor: "#B17016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779167,
    stopColor: "#824406"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997917,
    stopColor: "#C76254"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_971_8295",
    x1: 135,
    y1: 14,
    x2: 51.5,
    y2: 215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A68B35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6E485"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJackpotStarGoldDesktopIcon);
export default __webpack_public_path__ + "static/media/jackpot_star_gold_desktop_icon.e44ffbbd83f73b03f185e0dd1c48a688.svg";
export { ForwardRef as ReactComponent };